import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { tap } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Organisation {
  id: string;
  name: string;
  ownerName: string;
  email: string;
  phone: string;
  gstin?: string;
  whatsappNumber?: string;
  whatsappConnected: boolean;
  onboardingCompleted: boolean;
  plan?: string;
  payeeName?: string | null;
  bankName?: string | null;
  bankAccountNumber?: string | null;
  bankIfsc?: string | null;
  upiId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class OnboardingService {
  org = signal<Organisation | null>(null);

  constructor(private http: HttpClient) {}

  loadOrg() {
    return this.http.get<Organisation>(`${environment.apiUrl}/organisations/me`).pipe(
      tap((org) => this.org.set(org)),
    );
  }

  updatePaymentDetails(data: Pick<Organisation, 'payeeName' | 'bankName' | 'bankAccountNumber' | 'bankIfsc' | 'upiId'>) {
    return this.http.patch<Organisation>(`${environment.apiUrl}/organisations/me/payment-details`, data).pipe(
      tap((org) => this.org.set(org)),
    );
  }

  updateOrg(data: Partial<Organisation>) {
    return this.http.patch<Organisation>(`${environment.apiUrl}/organisations/me`, data).pipe(
      tap((org) => this.org.set(org)),
    );
  }

  completeOnboarding() {
    return this.http.post<Organisation>(`${environment.apiUrl}/organisations/me/complete-onboarding`, {}).pipe(
      tap((org) => this.org.set(org)),
    );
  }

  getServices() {
    return this.http.get<any[]>(`${environment.apiUrl}/services`);
  }

  getSystemServices() {
    return this.http.get<any[]>(`${environment.apiUrl}/services/system`);
  }

  selectSystemServices(serviceIds: string[]) {
    return this.http.post(`${environment.apiUrl}/services/select`, { serviceIds });
  }

  createService(data: { name: string; frequency: string }) {
    return this.http.post<any>(`${environment.apiUrl}/services`, data);
  }
}
